/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit GenerateAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import LoadingSpinner from 'DesignSystem/LoadingSpinner/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function GenerateAction({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/Action/Letter/Generate/GenerateAction"
  
}) {
let taskPatientValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'patient',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let loadingValueData = fromData.useDataValue({ viewPath,
context: 'loading',
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="auto"
 size="small"
 type="secondary"
 data="task.patient"
 disabled={!taskPatientValueData}
 onClick={onClick}
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Generate"
/>
<fromFlow.When is={loadingValueData}>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
 data="loading"
 marginLeft={dtSpaceXxxs}
>
{childProps => (
<LoadingSpinner
{...childProps}
  viewPath={`${viewPath}/LoadingSpinner`}
 height={16}
 width={16}
/>
)}
</TysiaButtonIcon>
</fromFlow.When>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}